import { FC } from 'react';
import { useTitle } from 'react-use';

import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { RoutedStepProps } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';
import { StepsOrchestrator } from '@savgroup-front-common/core/molecules/StepsOrchestrator';

import { IrshStepValues } from '../IrshPages.types';

import { useIssuesReasonsPage } from './IssuesReasonsPage.hooks';
import {
  ISSUES_REASONS_STEP_NAMES,
  ISSUES_REASONS_STEPS,
} from './IssuesReasonsPage.steps';
import { IssuesReasonsPageSubmitValues } from './IssuesReasonsPage.types';
import messages from './messages';

export const IssuesReasonsPage: FC<RoutedStepProps<IrshStepValues>> = ({
  onNextStep,
}) => {
  const { handleSubmit, order, isLoading } = useIssuesReasonsPage({
    onNextStep,
  });

  useTitle(buildPageTitle([messages.issuesReasonsTitlePage]));

  if (isLoading) {
    return null;
  }

  return (
    <StepsOrchestrator<IssuesReasonsPageSubmitValues>
      initialStep={ISSUES_REASONS_STEP_NAMES.SELECT_ISSUE}
      config={ISSUES_REASONS_STEPS}
      onSubmit={handleSubmit}
      withWizard={false}
      initialValues={{
        order,
      }}
    />
  );
};
